import React, { useState } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DescriptionIcon from '@mui/icons-material/Description';
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { RequestButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box';
import { postCreateFile } from "../func/api";
import { BaseDialog } from '../components/base_dialog'
import { REPORT_STATUS } from '../const/config';
import { validationCheckCheckResult, validationCheckCheckSummary, validationCheckEarthquake } from '../func/validation_check'


export default function CreateExcelDialog({ earthquake, checkResult, checkSummary, setCreateComplete, checkSummaryDataPrime, facilityDams }) {
    const [open, setOpen] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [isConfirmed, setIsConfirmed] = useState(false);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setIsConfirmed(false);
    };

    const handleSendApproval = async () => {
        try {
            const payload = {
                earthquake: earthquake,
                check_result: checkResult,
                check_summary: checkSummary,
                check_summary_prime: checkSummaryDataPrime,
            };
            let data = null
            // 第一報
            if (earthquake.report_status_uuid === REPORT_STATUS.UNSUPPORTED) {
                // エラーチェック
                const messageEarthquake = validationCheckEarthquake(earthquake)
                if (messageEarthquake) {
                    setAlertMessage(messageEarthquake);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }

                // エラーチェック
                const messageCheckResult = validationCheckCheckResult(checkResult, facilityDams)
                if (messageCheckResult) {
                    setAlertMessage(messageCheckResult);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }
                data = await postCreateFile("api/post_create_first_report", payload);
                // 1次点検
            } else if (earthquake.report_status_uuid === REPORT_STATUS.FISRTREPORT) {
                // エラーチェック
                const message = validationCheckCheckSummary(checkSummary)
                if (message) {
                    setAlertMessage(message);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }
                // エラーが無ければPOST
                data = await postCreateFile("api/post_create_primary_inspection_report", payload)

                // 2次点検
            } else {
                // エラーチェック
                const message = validationCheckCheckSummary(checkSummary)
                if (message) {
                    setAlertMessage(message);
                    setAlertOpen(true);
                    setAlertSeverity("error");
                    return
                }
                // エラーが無ければPOST
                data = await postCreateFile("api/post_create_secondary_inspection_report", payload)
            }
            const url = window.URL.createObjectURL(new Blob([data], { type: 'application/zip' }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "files.zip");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setAlertMessage("報告書の作成が完了しました。");
            setAlertSeverity("success");
            handleClose()
            setCreateComplete(true);
        } catch (error) {
            console.error("報告書の作成に失敗しました。：", error);

            setAlertMessage("報告書の作成に失敗しました。");
            setAlertSeverity("error");
        } finally {
            // Alert を表示
            setAlertOpen(true);
        }
    };

    return (
        <>
            <BoxSpaceCenter sx={{ flexDirection: 'column', gap: 2 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isConfirmed}
                            onChange={(e) => setIsConfirmed(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="報告内容を確認しました"
                />
                <RequestButton startIcon={<DescriptionIcon />} onClick={handleClickOpen} disabled={!isConfirmed}>
                    報告書作成
                </RequestButton>
                <BaseDialog
                    open={open}
                    onClose={handleClose}
                    title="報告書作成"
                    message={"報告書の作成を行います。\nよろしいですか？"}
                    onConfirm={handleSendApproval}
                    confirmText='作成'
                    cancelText='キャンセル'
                />
            </BoxSpaceCenter>
            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // 右上に表示
            >
                <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
